<footer class="goab-footer">
  <a class="link" href="https://alberta.ca">Go to Alberta.ca</a>
  <span class="copyright">©{{ copyrightYear }} Government of Alberta</span>
</footer>
